import { useEffect, useState } from 'react'

import { getBuildingsNG } from '../../../../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../../constants/form'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../../constants/pagination'
import { SIZE } from '../../../../constants/size'
import { useNotification } from '../../../../hooks'
import { getItemsIds } from '../../../../utils/common'
import { toBuildingSelectItems } from '../../../Building'
import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { FormModal } from '../../../Form'

import {
  BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING,
  BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS,
  QA_NAME_EDIT_BUILDINGS_MODAL,
} from './BuildingGroupsEditBuildingsActionModal.constants'
import {
  getInitialValues,
  getValidationSchema,
} from './BuildingGroupsEditBuildingsActionModal.utils'
import { FormFields } from './FormFields'

function BuildingGroupsEditBuildingsActionModal({
  formFieldsProps: {
    actionTypes = Object.values(getEntityActionTypeSelectOptions()),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  id,
  itemAction,
  onClose,
  onSubmit,
}) {
  const { handleAddErrorNotification } = useNotification()

  const [initialValues, setInitialValues] = useState(
    getInitialValues(EMPTY_LIST, itemAction)
  )
  const [isLoading, setLoading] = useState(Boolean(itemAction))
  const [prevDeps, setPrevDeps] = useState({ id, itemAction })

  if (id !== prevDeps.id || itemAction !== prevDeps.itemAction) {
    setPrevDeps({ id, itemAction })
    setLoading(Boolean(itemAction))
  }

  useEffect(() => {
    if (itemAction) {
      getBuildingsNG({
        building_group: id,
        size: PAGINATION_ALL_ITEMS_SIZE,
      })
        .then(({ data }) => {
          setInitialValues(
            getInitialValues(toBuildingSelectItems(data.items), itemAction)
          )
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [id, itemAction])

  function handleSubmit({ values }) {
    const payload = {
      [BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS]:
        values[BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS],
      ids: getItemsIds(
        values[BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING],
        'value'
      ),
    }

    onSubmit({
      payload,
      values,
    })
  }
  const validationSchema = getValidationSchema({ initialValues, itemAction })

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_EDIT_BUILDINGS_MODAL,
      }}
      formBodyProps={FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION}
      formFieldsProps={{ ...formFieldsProps, actionTypes, isLoading }}
      formTitle='Modal.EditBuildingsTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default BuildingGroupsEditBuildingsActionModal
